import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            <div className='bg-gradient-to-r from-slate-800 to-gray-900 py-20 w-10/12 mx-auto mt-20 rounded-3xl'>
                <p className='text-9xl text-center font-extrabold text-white'>4 0 4</p>
                <p className='text-white text-center text-6xl font-bold'>There's NOTHING Here!</p>
                <p className='text-white text-center text-3xl font-semibold'>...maybe the page you're looking for is not found or never existed</p>
            </div>
        </div>
    );
};

export default PageNotFound;